var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.unitStorePostErrors },
        on: {
          "update:errors": function($event) {
            _vm.unitStorePostErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "mt-5", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Unit",
                  dense: "",
                  "error-messages": _vm.unitStorePostErrors.id
                },
                model: {
                  value: _vm.id,
                  callback: function($$v) {
                    _vm.id = $$v
                  },
                  expression: "id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "my-0 py-0", attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Description",
                  dense: "",
                  "error-messages": _vm.unitStorePostErrors.description
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green",
                    block: "",
                    small: "",
                    dark: "",
                    dense: "",
                    loading: _vm.unitStorePosting
                  },
                  on: { click: _vm.store }
                },
                [_c("span", [_vm._v("Save")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }